export default {
  inserted(el, binding) {
    const options = {
      rootMargin: '100px',
      threshold: 0.1
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target
          const src = binding.value
          
          if (src) {
            img.src = src
            img.onload = () => {
              img.style.opacity = '1'
            }
            img.onerror = () => {
              console.error('图片加载失败:', src)
            }
          }
          
          observer.unobserve(img)
        }
      })
    }, options)

    observer.observe(el)

    el._lazyObserver = observer
  },
  unbind(el) {
    if (el._lazyObserver) {
      el._lazyObserver.disconnect()
    }
  }
}